<div class="container-fluid padding-top padding-bottom">
  <md-card *ngIf="!showLoading; else loading">
    <div class="row padding-bottom">
      <div class="col-md-12">
        <button class='btn btn-lg btn-primary'
                color="primary"
                (click)="goBack()">Go Back</button>
      </div>
      <div class="col-md-12 text-center">
        <h1>Locations</h1>
      </div>
    </div>
    <div class="row margin-bottom">
      <div class="col-xs-12 button-wrapper d-flex justify-content-center">
        <div class="btn-group center-block">
          <label class="btn btn-primary btn-lg"
                 [(ngModel)]="clientData.locationsOrderType"
                 btnRadio="ungrouped">
            No Groups</label>
          <label class="btn btn-primary btn-lg"
                 [(ngModel)]="clientData.locationsOrderType"
                 btnRadio="grouped">
            Groups</label>
        </div>
      </div>
    </div>
    <div *ngIf="clientData.locationsOrderType === 'ungrouped'; else grouped"
         class="row mt-3">
      <div class="col-xs-12 col-sm-4 col-sm-offset-4 margin-top text-center">
        <label>Drag to re-order locations</label>
        <div [dragula]="'locations-ungrouped-bag'"
             [dragulaModel]="clientData?.locationsOrder"
             class="sortable-wrapper">
          <div *ngFor="let locationKey of clientData?.locationsOrder"
               class="sortable-item">{{locationNames[locationKey]}} ({{locationKey}})</div>
        </div>
      </div>
    </div>

    <ng-template #grouped>
      <div class="row mt-3">
        <div class="col-xs-12 col-sm-8 col-sm-offset-2 col-md-6 col-md-offset-3">
          <div [dragula]="'group-bag'"
               [dragulaModel]="clientData.locationsGroups"
               class="sortable-wrapper">
            <div *ngFor="let group of clientData.locationsGroups"
                 class="row">
              <div class="col-xs-12">
                <div class="sortable-item text-left p-3">
                  <div class="row">
                    <div class="col-xs-12 col-sm-6">
                      <label>Group Name {{ group.slug ? '(url slug: '+group.slug+')' : '' }}</label>
                      <input class="full-width"
                             pInputText
                             (change)="setSlug(group)"
                             [(ngModel)]="group.title" />
                    </div>
                    <div class="col-xs-12 col-sm-6">
                      <label>Group Locations</label>
                      <p-multiSelect [styleClass]="'full-width'"
                                     [options]="locationOptions"
                                     [(ngModel)]="group.locationKeys"></p-multiSelect>
                    </div>
                  </div>
                  <div class="row mt-3">
                    <div class="col-xs-12">
                      <label>Group Blurb</label>
                      <textarea [froalaEditor]="options"
                                [(froalaModel)]="group.blurb"
                                class="full-width"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-xs-12 d-flex justify-content-center">
              <button class="btn btn-accent btn-lg"
                      (click)="clientData.locationsGroups.push({})">
                <i class="fa fa-plus"
                   aria-hidden="true"></i> Add Group
              </button>
            </div>
          </div>
        </div>
      </div>
    </ng-template>
    <div class="row padding-top">
      <div class="col-xs-12">
        <button style="float: right;"
                (click)="save()"
                class="btn btn-lg btn-secondary"
                color="accent">Update</button>
      </div>
    </div>
  </md-card>
</div>

<ng-template #loading>
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</ng-template>
<div *ngIf="showSpinner">
  <div class="spinner">
    <md-spinner color="accent"></md-spinner>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/ng2/app/admin-portal/locations-data/locations-data.component.html